import type { OAuth2Config, OAuth2Provider } from '@edusense/shared-auth-core'
import { adminAuthConfig } from './adminAuthConfig'
import { buildAdminOAuthConfig, getAdminAuthServerUrl } from './adminOAuth'

type CleanupFn = (storageKeys?: Partial<typeof adminAuthConfig.storage>) => void
type LoginFn = (
  provider: OAuth2Provider,
  config?: Partial<OAuth2Config>,
  prompt?: string,
) => void

type StartAdminPortalLoginOptions = {
  authServerUrl?: string
  cleanup?: CleanupFn
  login?: LoginFn
}

export const startAdminPortalLogin = (
  options: StartAdminPortalLoginOptions = {},
): void => {
  const authServerUrl = options.authServerUrl || getAdminAuthServerUrl()
  const oauthConfig = buildAdminOAuthConfig({ authServerUrl })

  if (options.cleanup && options.login) {
    options.cleanup(adminAuthConfig.storage)
    options.login('internal', oauthConfig, 'login')
    return
  }

  void import('@edusense/shared-auth-core').then(
    ({ performFullCleanup, loginWithRedirect }) => {
      const cleanup = options.cleanup || performFullCleanup
      const login = options.login || loginWithRedirect

      cleanup(adminAuthConfig.storage)
      login('internal', oauthConfig, 'login')
    },
  )
}
